import {
  HeaderCell,
  HeaderCellActions,
  HeaderCellTitle,
  SortButton,
} from "@bst/react-ui";
import { Column, SortDirection } from "@bst/react-data-grid";
import clsx from "clsx";
import { ComponentPropsWithoutRef, ElementRef, Ref, forwardRef } from "react";

export type SortableHeaderProps = ComponentPropsWithoutRef<
  typeof HeaderCell
> & {
  column: Column<any>;
  sortDirection?: SortDirection;
  onToggleSort?: (key: string) => void;
};

/**
 * SortableHeader is used as a custom header cell renderer for the User Management DataGrid.
 */
export const SortableHeader = forwardRef(function SortableHeader(
  {
    className,
    column,
    tabIndex,
    sortDirection,
    onToggleSort,
    ...props
  }: SortableHeaderProps,
  ref: Ref<ElementRef<typeof HeaderCell>>
) {
  return (
    <HeaderCell
      ref={ref}
      className={clsx(column.headerCellClass, className)}
      tabIndex={tabIndex}
      {...props}
    >
      <HeaderCellTitle>{column.name}</HeaderCellTitle>
      <HeaderCellActions>
        <SortButton
          direction={sortDirection}
          onToggleSort={() => onToggleSort?.(column.key)}
          data-testid={`sort-button-${column.key}`}
          data-direction={sortDirection}
        />
      </HeaderCellActions>
    </HeaderCell>
  );
});
